import { jsx as _jsx } from "react/jsx-runtime";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import IconButton from "@mui/material/IconButton";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
export function CopyToClipboardButton(props) {
    const t = useUiTranslator();
    const title = t("ConfigurationRenderer:JsonViewer.copyToClipboard", "Copy to clipboard");
    return (_jsx(IconButton, { title: title, onClick: () => {
            navigator.clipboard.writeText(JSON.stringify(props.data, null, 2));
        }, children: _jsx(ContentCopyIcon, {}) }));
}
//# sourceMappingURL=CopyToClipboardButton.js.map